var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    ref: "icon",
    class: ["icon", _vm.variant ? "icon--" + _vm.variant : null].concat(
      _vm.classes
    ),
    attrs: { "data-svg": _vm.dataSvg },
    on: { click: _vm.clickHandler }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }